import { CallToAction } from 'components/CallToAction'
import { GatsbyImage } from 'gatsby-plugin-image'
import { heading, section } from '../classes'
import { prepareData } from 'utils/googleData'
import React from 'react';
import  ThreeArrows  from './three-arrows.png'
import Link from 'components/Link'

const suporPowers = [
    {
        title: 'Focus',
        description:
            'OKRs focus on just 3-5 goals per quarter. This forces companies to make hard choices to eliminate tasks that don’t matter, create value and improve user experience.',
    },
    {
        title: 'Alignment',
        description:
            ' OKRs are a powerful tool for aligning teams and promoting accountability. They give employees a clear understanding of how they contribute to the overall success of the company.',
    },
    {
        title: 'Tracking',
        description:
            'Data-driven OKRs are the new way to set goals. Gone are the days when managers and employees could only set an annual performance goal. Data is everywhere, and leaders in agile organizations know how to use it to define their best strategies.',
    },
    {
        title: 'Transparency',
        description:
            'At OKRs, everyone can see the goals and progress at any level of the company. You can update your own goals, see progress in the form of progress bars, and easily find goals that match your interests.',
    },
    {
        title: 'Stretch',
        description:
            'Great companies use stretch goals to push their teams to achieve what might seem impossible — and receive support when things fall short.',
    },
]

export function SuperPowers(props) {
    const { enable, title, subtitle, description, homeMarketsTitle, cta, markets, direction, text, style, gatsbyImage, sections, gatsbyImage2 } = prepareData({ props })
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
    return (
        <section dir={direction} className={section()}>
        <div dir={direction} className="grid grid-cols-1 gap-[70px] justify-items-center lg:grid-cols-2 md:p-[16px] p-[24px] ">

                <div className=" md:p-[16px] p-[24px] md:items-center items-start">
                    <h3 className="text-[#00244d] text-[40px] leading-[1.5] mb-[28px] max-w-[490px] font-light flex flex-col md:items-center items-start">
                        OKRs <br /> 5 Superpowers
                    </h3>

                    <div
                        className="cursor-pointer w-[150px] h-[150px] flex flex-col items-center justify-center text-white bg-gradient-to-r from-[#047393] to-[#24b7ff] rounded-[4px] transition-bg ease-in-out duration-200 hover:from-[#24b7ff] hover:to-[#047393]"
                    >
                        <img
                            src={ThreeArrows}
                            alt="arrows icon"
                            width="auto"
                            height="auto"
                        />
                            <Link
                                to='https://app.ilpapps.com/register'
                                className="text-white"
                            >
                                Start for free
                            </Link>
                    </div>
                </div>

                <div className="max-w-[550px]">
                    {suporPowers.map(({ title, description }, index) => (
                        <div
                            className="flex gap-[30px] mb-[50px]"
                            key={index}
                        >
                            <div
                                className="text-[#18171c] text-[24px]"
                                style={{
                                    margin: '10px 0 0',
                                }}
                            >
                                0{index + 1}/
                            </div>

                            <div className="item-content">
                                <div className="text-[36px] text-[#00536b] mb-[10px]">
                                    {title}
                                </div>
                                <div className="text-[18px] text-[#18171c] opacity-80">
                                    {description}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
